<div class="report-viewer-container"
     data-testid="report-container-viewer">
  @if (isLoading) {
  <p-message severity="info"
             class="loading-message"
             data-testid="report-container-loading">
    Loading report...
  </p-message>
  } @else if (errorMessage) {
  <p-message [severity]="errorSeverity"
             class="error-message"
             data-testid="report-container-error">
    {{ errorMessage }}
  </p-message>
  }
</div>
